<template>
    <div class="accordion" v-bind:class="{ open: open }">
        <div class="accordion__header" @click="toggle()">
            <slot name="header"></slot>
        </div>
        <div class="accordion__content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AccordionComponent',
        props: ['classes', 'isOpen'],
        data() {
            return {
                open: false
            }
        },
        mounted() {
            if (this.isOpen) {
                this.open = this.isOpen
            }
        },
        methods: {
            toggle() {
                this.open = ! this.open
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Accordion.vue?31c03093